// extracted by mini-css-extract-plugin
export default {"selfAssignButton":"AssigneesSection-module__selfAssignButton__ZU49Y7U"};